import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IExtendedUsuario } from '../../models/IUsuario';
import { IAcesso } from '../../models';

export interface IModuleInfo {
  IdProduto: number
  Nome: string
}

interface IUserState {
  currentUser?: IExtendedUsuario
  modules: IModuleInfo[]
  access?: IAcesso
}

const initialState: IUserState = {
  currentUser: undefined,
  modules: [],
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCurrentUserState(state, action: PayloadAction<IExtendedUsuario>) {
      state.currentUser = action.payload
    },
    setCurrentUserModulesState(state, action: PayloadAction<IModuleInfo[]>) {
      state.modules = action.payload
    },
    setCurrentAccessState(state, action: PayloadAction<IAcesso>) {   
      state.access = action.payload
    }
  },
});

export const {
  setCurrentUserState,
  setCurrentAccessState,
  setCurrentUserModulesState
} = userSlice.actions;

export const userReducer = userSlice.reducer;